import { State, Action, StateContext, Selector } from '@ngxs/store';
import { EditStateModel } from './edit.state.model';
import { SetView, ShowColumns, ShowColumn, ResetEditPage, NextView, PreviousView, SetObjectVisibility, SetObjectPickable } from './edit.actions';
import { EditViewEnum } from '../models/edit-view.enum';
import { EditPaintState } from './paint/edit.paint.state';
import { RecordChapterVisibilityState, RecordChapterPickableState } from '../../story/state/chapters/story.chapters.actions';

import { ResetPaint } from './paint/edit.paint.actions';
import { ToggleVisibleNodes, TogglePickableNodes } from 'src/app/engine/state/nodes/engine.nodes.actions';

const initialState = {
  view: EditViewEnum.Chapter,
  showColumns: true,
  showLeftColumn: true,
  showRightColumn: true,
  showHeader: true,
  showFooter: true,
  record: true
};

@State<EditStateModel>({
  name: 'edit',
  defaults: initialState,
  children: [
    EditPaintState
  ]
})
export class EditState {
  @Selector()
  static getView(state: EditStateModel) {
    return state.view;
  }

  @Selector()
  static getShowColumns(state: EditStateModel) {
    return state.showColumns;
  }

  @Selector()
  static getShowLeftColumn(state: EditStateModel) {
    return state.showLeftColumn;
  }

  @Selector()
  static getShowRightColumn(state: EditStateModel) {
    return state.showRightColumn;
  }

  @Selector()
  static getShowHeader(state: EditStateModel) {
    return state.showHeader;
  }

  @Selector()
  static getShowFooter(state: EditStateModel) {
    return state.showFooter;
  }

  @Selector()
  static getRecord(state: EditStateModel) {
    return state.record;
  }

  @Action(SetView)
  setView(context: StateContext<EditStateModel>, action: SetView) {
    context.patchState({
      view: action.view
    });
  }

  @Action(NextView)
  nextView(context: StateContext<EditStateModel>, action: NextView) {
    const { view } = context.getState();

    const views = Object.values(EditViewEnum);
    const next = views[views.indexOf(view) + 1] || views[0];
    
    context.patchState({
      view: next
    });
  }

  @Action(PreviousView)
  previousView(context: StateContext<EditStateModel>, action: NextView) {
    const { view } = context.getState();

    const views = Object.values(EditViewEnum);
    const previous = views[views.indexOf(view) - 1] || views[views.length - 1];
    
    context.patchState({
      view: previous
    });
  }

  @Action(ShowColumns)
  showColumns(context: StateContext<EditStateModel>, action: ShowColumns) {
    context.patchState({
      showColumns: action.show
    });
  }

  @Action(ShowColumn)
  showColumn(context: StateContext<EditStateModel>, action: ShowColumn) {
    switch (action.column) {
      case 'left':
        context.patchState({
          showLeftColumn: action.show
        });
        break;
      case 'right':
        context.patchState({
          showRightColumn: action.show
        });
        break;
      case 'header':
        context.patchState({
          showHeader: action.show
        });
        break;
      case 'footer':
        context.patchState({
          showFooter: action.show
        });
        break;
    }
  }

  @Action(ResetEditPage)
  resetEditPage(context: StateContext<EditStateModel>, action: ResetEditPage) {
    context.setState(initialState);
    context.dispatch(new ResetPaint());
  }

  @Action(SetObjectVisibility)
  setObjectVisibility(context: StateContext<EditStateModel>, action: SetObjectVisibility) {
    // relay to the engine
    context.dispatch(new ToggleVisibleNodes(action.nodes, action.visible));
    
    // record with current chapter
    const record = context.getState().record;
    context.dispatch(new RecordChapterVisibilityState(action.nodes, action.visible, record));
  }

  @Action(SetObjectPickable)
  setObjectPickable(context: StateContext<EditStateModel>, action: SetObjectPickable) {
    context.dispatch(new TogglePickableNodes(action.nodes, action.pickable));

    // record with current chapter
    const record = context.getState().record;
    context.dispatch(new RecordChapterPickableState(action.nodes, action.pickable, record));
  }

}
